// Lib
import { handleActions } from 'redux-actions';

// Actions
import {
  AddLinks,
  ChangeUsername,
  PassUserOnboarding,
  SetAccountTooltips,
  SetAuth,
  SetDataCollectionSettings,
  SetMarbleUser,
  SetSubscriptionsStatus,
  SetUserAnalytics,
  UpdateAdvancedColor,
  UpdateAuths,
  UpdateAuthsStatus,
  UpdateBackgroundSettings,
  UpdateMarkup,
  UpdateTheme,
  UpdatedMarbleUser,
  UpdatedMarbleUserAuths,
  UserDataLoaded,
  UserLogout,
} from '@actions/user';

// Types
import type { UserPayload, UserState } from './types';

// Initial State
import { initialState } from './initialState';

// Handlers
import {
  addLinksHandler,
  changeUsernameHandler,
  passUserOnboardingHandler,
  setMarbleUserHandler,
  updatedMarbleUserAuthsHandler,
  updatedMarbleUserHandler,
  userDataLoadedHandler,
  userLogoutHandler,
} from './userDataHandlers';

import {
  setAuthHandler,
  updateAuthsHandler,
  updateAuthsStatusHandler,
} from './authHandlers';

import {
  setAccountTooltipsHandler,
  setDataCollectionSettingsHandler,
  setSubscriptionsStatusHandler,
  setUserAnalyticsHandler,
  updateAdvancedColorHandler,
  updateBackgroundSettingsHandler,
  updateMarkupHandler,
  updateThemeHandler,
} from './settingsHandlers';

export default handleActions<UserState, UserPayload>(
  {
    [SetMarbleUser.toString()]: setMarbleUserHandler,
    [UpdatedMarbleUserAuths.toString()]: updatedMarbleUserAuthsHandler,
    [UserDataLoaded.toString()]: userDataLoadedHandler,
    [UpdatedMarbleUser.toString()]: updatedMarbleUserHandler,
    [AddLinks.toString()]: addLinksHandler,
    [ChangeUsername.toString()]: changeUsernameHandler,
    [PassUserOnboarding.toString()]: passUserOnboardingHandler,
    [SetUserAnalytics.toString()]: setUserAnalyticsHandler,
    [UserLogout.toString()]: userLogoutHandler,
    [UpdateAuths.toString()]: updateAuthsHandler,
    [UpdateAuthsStatus.toString()]: updateAuthsStatusHandler,
    [SetAuth.toString()]: setAuthHandler,
    [UpdateBackgroundSettings.toString()]: updateBackgroundSettingsHandler,
    [SetSubscriptionsStatus.toString()]: setSubscriptionsStatusHandler,
    [SetAccountTooltips.toString()]: setAccountTooltipsHandler,
    [UpdateTheme.toString()]: updateThemeHandler,
    [UpdateMarkup.toString()]: updateMarkupHandler,
    [UpdateAdvancedColor.toString()]: updateAdvancedColorHandler,
    [SetDataCollectionSettings.toString()]: setDataCollectionSettingsHandler,
  },
  initialState,
);

// Export types for external use
export type { UserState } from './types';
